import drag from './drag'
import scroll from './scroll'
import next from './next'
import notnext from './not-next'
import tablefixed from './table-fixed'
import kyeresize from './resize'

export default {
  drag,
  scroll,
  next,
  notnext,
  tablefixed,
  kyeresize
}



// WEBPACK FOOTER //
// ./src/public/directives/index.js